import dayjs from "dayjs";
import { showErrorNotification, showSuccessNotification, showWarningNotification } from "../components/common/NotiService";
import { app } from "../config";
import { AGENT_STATE, AGENT_STATES, MODES, sideMenuList } from "../constants";
import { pauseToggle, setCurrentLocationTimeAndRescheduleTime, setIsCallAttended, setIsCallBackCallNotAttended, setIsComponentOnCall, setPreviewRetryCountdown, setScreenpopURL } from "../context/callSlice";
import { addNewTab, loading, removeTab, setActiveTab } from "../context/dashboardSlice";
import { pauseAfterSession, pauseTimeExceeded, setChatParkingApiCount, showExceededTimelimit, showPauseAfterSessionTime } from "../context/digitalSlice";
import { store } from "../context/store";
import { setAgentStateDuration, setAutoUpdateAgentState, setPauseReason, setReUpdateTimer, setTimeAfterPauseReason } from "../context/timerSlice";
import {
    clearMultiDisposition, handleDispositionEnable, minimizeCall, setActiveToggle, setAgentUserId,
    setDispositionReqbody, setDispositionValues, setExceptionState, setIsPreviewCampaignNumberScreenOpened,
    setLoginDetails, setLoginViaAppData, setManualData, setMode, setNotReadyTimeOut, setOTPVerify,
    setPreviewCampaignNumberDetails, setPreviewNumberCustomerInfo, setScreenRecordCancelled,
    setBrowserSessionId, setParkingChatsCount,
    setBlendedModeActiveDialer, setScreenRecording,
} from "../context/toolbarSlice";
import { agentService, callControlsJsonList, getCustomerInfo, getQueueChatsCount, screenRecordingWithApi } from "./agent.service";
import { dropAgentFromCall, endCurrentCall } from "./authService";
import HttpService from "./http.service";
import LocalStorageService from "./localstorage.service";
import Logger from "./logger.service";
import { forceCloseAllNotification, handleTbNotifications, unRegisterServiceWorker } from "./notificationHandler";
import sipService from "./sip.service";
import { handleDropCall, releaseAgent } from "./webEventHandlers";
import WSocketService from "./websocket.service";
import { v4 as uuidv4 } from 'uuid'

export function setLoginData(agentData) {
    agentData.agentInfo = JSON.parse(agentData.agentInfo);
    setUserId(agentData)
    agentData.smsTemplates = JSON.parse(agentData.smsTemplates);
    agentData.pauseReasons = JSON.parse(agentData.pauseReasons);
    agentData.params = setParams(agentData);
    setAgentMode(agentData.agentInfo, agentData.params, agentData.roles)
    store.dispatch(setLoginDetails(agentData))   // setting agent details to redux
    LocalStorageService.removeItem('callData')
    LocalStorageService.removeItem('agentCountDown');
    store.dispatch(setAgentStateDuration(0));
    store.dispatch(setAutoUpdateAgentState({
        countDown: null,
        altered: false
    }))
    store.dispatch(setLoginViaAppData({
        customer: null,
        agentid: null,
        phoneNumber: null,
        pin: null
    }))
}
export const addInteractionTab = (isChatAssist) => {
    const visibleTabs = store.getState()?.dashboard?.visibleTabs ?? [];
    const activeTab = store.getState()?.dashboard?.activeTab;
    const noSpaceInToolbar = window.matchMedia('(max-width: 650px)').matches;
    if (isChatAssist && !noSpaceInToolbar) {
        if (Array.isArray(visibleTabs) && !visibleTabs.includes("Interaction Hub")) {
            store.dispatch(addNewTab("Interaction Hub"));
        } else {
            if (activeTab === 'Interaction Hub') {
                return;
            }
            store.dispatch(setActiveTab('Interaction Hub'))
            LocalStorageService.setItem("DashboardActiveTab", 'Interaction Hub')
        }
    }
}

export async function StartVideoScreenRecording(params) {
    try {
        let URL = HttpService.getURL('videoRecordingURL');
        let agentDetails = getAgentData();
        let customer = agentDetails.customer
        const formattedDate = dayjs().format('YYYY-MM-DD');
        let payload = {
            ucid: params?.ucid ?? '',
            videoUrl: `${URL}/videos/${customer}/${formattedDate}/${params.ucid}.mp4`,  // new code 
        };
        const resp = await agentService("tbStartVideoScreenRecording", payload);
        if (resp?.status === "success") {
            Logger.log("Video recording api success");
        } else {
            Logger.log("Video recording api failed");
            Logger.info(`${resp.message}`);
        }
    } catch (e) {
        Logger.log("Video recording api failed");
        Logger.log(e);
    }
}
// Persistent AgentMonitorSDK instance — created on 'start', cleared on 'stop'
let _agentMonitorSdk = null;

export function registerAgentMonitorSdk(instance) {
    _agentMonitorSdk = instance;
}

export function getAgentMonitorSdk() {
    return _agentMonitorSdk;
}

export async function handleScreenRecording(state, action, ucid) {
    console.log("screen-> recording :: state,action",state,action);
    const ROLE_SCREEN_RECORDING = getRoleStatus("ROLE_SCREEN_RECORDING");
    let agentData = getAgentData();
    const isAgantScreenRecordingEnabled = agentData?.agentInfo?.screenRecording ?? false;
    // const BARGE_IN_ONLY_RECORD = isSettingEnabled('BARGE_IN_ONLY_RECORD');
    if (!ROLE_SCREEN_RECORDING || !isAgantScreenRecordingEnabled) {
        console.log("screen->Recording ::Screen recording denied: Role or Agent setting is disabled.");
        return;
    }
    switch (action) {
        case 'start':
            // if (!BARGE_IN_ONLY_RECORD) {
            //     console.log("screen->Recording :: recording star request received");
            //     await finalRecording(state, action);
            // }
            // else if (BARGE_IN_ONLY_RECORD || isUcidRecordingMode) {
                await finalRecording(state, action, ucid);
            // }
            break;
        case 'stop':
            console.log("screen->Recording :: recording stop request received");
            await finalRecording(state, action, ucid);
            break;
        case 'pause':
            console.log("screen->Recording :: recording pause request received");
            await finalRecording(state, action, ucid);
            break;
        case 'resume':
            console.log("screen->Recording :: recording resume request received");
            await finalRecording(state, action, ucid);
            break;
        default:
            break;
    }
}
export function isUcidRecordingMode() {
    return getScreenRecordingMode() === 'ucid';
}

export function getScreenRecordingMode() {
    const agentData = getAgentData();
    const isScreenRecordingEnabled = agentData?.agentInfo?.screenRecording ?? false; // one agent form setting
    const screen_recording_option = callControlsJsonList()?.screen_recording_option; // new setting
    if (isScreenRecordingEnabled) {
        if (screen_recording_option === true){
            return 'ucid';
        } else {
            return 'full';
        }
    }
    return 'full';
}
export async function finalRecording(state, action, ucidOverride) {
    console.log("screen-> recording :: state,action2", state, action);
    const SCREEN_RECORD_BY_APP = isSettingEnabled("SCREEN_RECORD_BY_APP");
    const SCREEN_RECORD_URL = HttpService.getURL("screenRecordingUrl");
    let agentData = getAgentData();
    const handleScreenRecordCancel = (err) => {
        let screenRecordMandatory = !Boolean(callControlsJsonList()?.not_enforce_screen_record);
        if (screenRecordMandatory){
            if (err && (err?.name === "NotAllowedError" || (err?.message ?? err)?.includes("NotAllowedError: Permission denied") || (err?.message ?? err)?.includes("triggered NotAllowedError"))) {
            store.dispatch(setScreenRecordCancelled(true));
        }
    }
    };
    try {
        let data = store.getState().toolbar;
        const usId = data?.usId ?? '';
        const callState = store.getState();
        const callSlice = callState.call;
        const ucid = ucidOverride || callSlice?.callDetails?.ucid || '';
        if (SCREEN_RECORD_BY_APP) {
            console.log("screen->Recording ::SCREEN_RECORD_BY_APP is called ");
            screenRecordingWithApi({
                action,
                clientId: usId,
                agentId: String(agentData.agentUniqId) ?? '',
                userName: agentData?.customer ?? '',
                agentName: agentData?.agentInfo?.agentName ?? '',
                uploadUrl:`${SCREEN_RECORD_URL}`,
                recordingMode: getScreenRecordingMode(),
                ucid,
                format: 'webp',
                quality: 0.5,
                intervalMs: 1000
            });
        } 
        else if (window?.AgentMonitorSDK) {
            console.log("screen->Recording :: AgentMonitorSDK called...");
            if (action === 'start') {
                    const ROLE_SCREEN_RECORDING = getRoleStatus("ROLE_SCREEN_RECORDING");
                    const isAgantScreenRecordingEnabled = agentData?.agentInfo?.screenRecording ?? false;
                    const isScreenRecordingEnabledByApp = store.getState().toolbar.isScreenRecordingEnabledByApp;
                if (!agentData?.agentUniqId) {
                    console.warn("screen->Recording :: agentUniqId is not available, skipping recording start");
                    return;
                }
                const recordingMode = getScreenRecordingMode();
                console.log("screen->Recording :: ROLE_SCREEN_RECORDING, isAgantScreenRecordingEnabled  , SCREEN_RECORD_BY_APP , isScreenRecordingEnabledByApp value--->",
                     ROLE_SCREEN_RECORDING, isAgantScreenRecordingEnabled, 
                      SCREEN_RECORD_BY_APP, isScreenRecordingEnabledByApp);

                console.log("screen recording in util : final recordingMode ", recordingMode);
                _agentMonitorSdk = new window.AgentMonitorSDK({
                    endpoint: `${SCREEN_RECORD_URL}/files`,
                    agentId: String(agentData.agentUniqId) ?? '',
                    userName: agentData.customer ?? '',
                    agentName: agentData?.agentInfo?.agentName ?? '',
                    userTimeZone: agentData.agentInfo.user.userTimezone,
                    recordingMode,
                    ucid,
                    quality: 0.5,
                    onStart: () => {
                        console.log("screen->Recording :: recording-------started ---------");
                        store.dispatch(setScreenRecording(true));
                        const isCallActive = store.getState().call.isCallActivityPresent;
                        if ((recordingMode === 'ucid' || recordingMode === 'barge') && !isCallActive) {
                            console.log("recordingMode is", recordingMode, "so pausing the recording");
                            setTimeout(() => finalRecording("login", "pause"), 500);
                        }
                    },
                    onEnded: () => {
                        console.log("screen->Recording :: screen share stopped from system");
                        store.dispatch(setScreenRecording(false));
                        const screenRecordMandatory = !Boolean(callControlsJsonList()?.not_enforce_screen_record);
                        if (screenRecordMandatory) {
                            store.dispatch(setScreenRecordCancelled(true));
                        }
                    },
                    onError: (e1) => {
                        console.log("screen recording onError: triggered", e1);
                        handleScreenRecordCancel(e1);
                    },
                    onUploadSuccess: (info) => console.log('screen->Recording :: frame uploaded', info.size, 'bytes'),
                    onStop: () => {
                        console.log('screen->Recording :: AgentMonitorSDK stopped');
                    },
                });
                _agentMonitorSdk.start(); // fire-and-forget — start() handles its own async flow
            } else if (action === 'stop') {
                _agentMonitorSdk?.stop();
                _agentMonitorSdk = null;
            } else if (action === 'pause') {
                _agentMonitorSdk?.pause();
            } else if (action === 'resume') {
                _agentMonitorSdk?.resume();
            }
        }
    } catch (e) {
        // console.log("screen recording failed: ", record, state, action, usId, app.toolbarInstance, agentData.customer, agentData.agentUniqId,ucid);
        console.log(e);
    }
}

/**
 * Updates the UCID on the active AgentMonitorSDK instance.
 * Call this whenever a new call starts mid-session (ucid mode).
 */
export function updateScreenRecordingUcid(ucid) {
    _agentMonitorSdk?.setUcid(ucid);
}


function setParams(data) {
    let params = {};
    if (data.userParameters) {
        data.userParameters.forEach(element => {
            params[element.ParameterCode] = element.ParameterValue ? element.ParameterValue : element.DefaultValue;
        });
    }
    return params;
}

export function getParam(key) {
    let agentData = getAgentData();
    let params = agentData.params || null;
    let paramValue = null;
    if (params) {
        if (params.hasOwnProperty(key)) {
            paramValue = params[key];
        }
    }
    return paramValue;
}
export function isSettingEnabled(key) {
    const agentData = getAgentData();
    const params = agentData?.params || {};
    return params[key] === true || params[key] === "true"; // Check both types: boolean and string 'true' and return true or false
}


export const maskEntireNumber = (msg) => {
    if (!(getAgentData().userRoles.CUST_MASKING)) {
        return msg;
    }
    try {
        const regexPattern = new RegExp(`\\b\\d{${5},}\\b`, 'g');
        return msg.replace(regexPattern, (match) => '*'.repeat(match.length));
    }
    catch (e) {
        return msg
    }
}

export function isMaskNumberEnabled(number) {
    if (getParam("MASK_CUSTOMER_NUMBER") === "true" || getParam("MASK_CUSTOMER_NUMBER") === true) {  // setting --- Hide customer phone no ---> ( MASK_CUSTOMER_NUMBER ) 
        let NumberOfDigitsToShow = Number(getParam("SHOW_CUST_NUMBER_N"));    // setting  ----> Show Customer Number from Last N numbers  ---?( SHOW_CUST_NUMBER_N ) 
        if (NumberOfDigitsToShow <= 0) {
            const masked = "*".repeat(number && number.length);  // if number is less then or equal to zero  masking entire number to **
            return masked
        }
        else if (NumberOfDigitsToShow > 0) {  // checking if number is greater then 0 
            const firstLetters = (number || "").slice(0, -NumberOfDigitsToShow);
            const masked = "*".repeat(firstLetters.length);
            const lastDigits = (number || "").slice(-NumberOfDigitsToShow);
            return masked + lastDigits;
        }
        else {
            const masked = "*".repeat(number && number.length);   // making entire number if SHOW_CUST_NUMBER_N is not a number;
            return masked
        }
    }
    else {
        return number;   // If masking is not enabled, return the original number
    }
}

let availableModes = [];

function setAgentMode(agentInfo, params, roles) {
    availableModes = [];
    Object.values(MODES).forEach((mode, i) => {
        if (agentInfo[mode]) {
            availableModes.push(mode);
        }
    });
    store.dispatch(setMode(getDefaultMode(params, roles)));
}

export const getAvailableModes = () => availableModes;

export function getDefaultMode(params, roles) {
    const p = params ?? getAgentData()?.params ?? {};
    const blendedAsDefault = p?.ENBL_DFLT_BLENDED === true || p?.ENBL_DFLT_BLENDED === "true";
    const hasBlendedRole = roles != null
        ? roles.some(r => r.name === 'ROLE_BLENDED')
        : (getRoleStatus("ROLE_BLENDED") ?? false);
    return (blendedAsDefault && hasBlendedRole && availableModes.includes(MODES.BELNDED)) ? initBlendedModeAsManual() : availableModes[0];
}
function initBlendedModeAsManual(){
    store.dispatch(setBlendedModeActiveDialer('Manual'));
    LocalStorageService.setItem('blendedModeActiveDialer', 'Manual');
    return MODES.BELNDED
}
export function getAgentData() {
    let agentData = store.getState().toolbar.loginDetails;
    isLoginDataPresent('getAgentData')
    return agentData;
}
export async function PreviewReset(callPreviewCmp) {
    const blendedModeActiveDialer = store.getState().toolbar.blendedModeActiveDialer;
    const previewDataAfterRefresh = store.getState().toolbar.previewCampaignNumberDetails;
    const campaignSelectedState = previewDataAfterRefresh?.campaignSelectedState || false;
    const selectedCampaingNumberDetails = previewDataAfterRefresh?.selectedCampaingNumberDetails || [];
    let mode = store.getState().toolbar.agent.mode;

    closeAllPreviewScreenpops();
    if ((mode === "blended" && blendedModeActiveDialer === "Preview" && campaignSelectedState) || (mode === "preview" && campaignSelectedState)) {
        await resetPreviewNumber(selectedCampaingNumberDetails?.id, callPreviewCmp ? true : false);
    }
}
export async function resetPreviewNumber(previewId, callPreviewCmp = true) {
    store.dispatch(loading(true));
    try {
        const resp = await agentService("tbResetPreviewNumber", { params: previewId });
        if (resp.resp === "Success") {
            Logger.log("Success");
            if (callPreviewCmp) {
                await getPreviewCampaings();
            }
        }
        else {
            Logger.info(`${resp.message}`)
        }
        store.dispatch(loading(false));
    }
    catch (e) {
        Logger.log(e);
        store.dispatch(loading(false));
    }
};


let _previewRetryTimer = null;
let _previewRetryCountdown = null;

export function clearPreviewRetryTimer() {
    if (_previewRetryTimer) {
        clearTimeout(_previewRetryTimer);
        _previewRetryTimer = null;
    }
    if (_previewRetryCountdown) {
        clearInterval(_previewRetryCountdown);
        _previewRetryCountdown = null;
    }
    store.dispatch(setPreviewRetryCountdown(null));
}

export async function getPreviewCampaings(autoSelect = true) {
    clearPreviewRetryTimer();
    const previewDataAfterRefresh = store.getState().toolbar.previewCampaignNumberDetails;
    const selectedCampaignData = previewDataAfterRefresh?.selectedCampaignData || null;
    const trueCallerSettingFlag = isSettingEnabled("INTEG_TRUECALLER");
    try {
        store.dispatch(loading(true));
        await agentService('tbGetPreviewCampaigns', {
            trueCallerFlag: trueCallerSettingFlag
        }).then((resp) => {
            store.dispatch(setIsPreviewCampaignNumberScreenOpened(false));
            store.dispatch(loading(false));
            let campaignList = [];
            if (resp.previewCampsJson && resp.previewCampsJson.length > 0) {
                Logger.info("Available preview Campaigns (JSON format)");
                campaignList = resp.previewCampsJson.map((camp) => ({
                    campaignName: camp.cname,
                    campaignId: camp.cid,
                    maxCount: camp.pCount,
                    trueCallerFlag: camp.truCallFlg,
                    autoDialTimePreview: camp.timer,
                    screenpopUrl: camp.spop !== undefined ? camp.spop : undefined
                }));
            } else if (resp.previewCamps && resp.previewCamps.length > 0) {
                Logger.info("Available preview Campaigns");
                campaignList = resp.previewCamps.map((previewcampData) => {
                    const PreviewCampaings = previewcampData.split("~");
                    const trueCallerCampaignFlag = PreviewCampaings.length > 3 ? PreviewCampaings[3] : false;
                    return {
                        campaignName: PreviewCampaings[0],
                        campaignId: PreviewCampaings[1],
                        maxCount: PreviewCampaings[2],
                        trueCallerFlag: trueCallerCampaignFlag,
                        autoDialTimePreview: null
                    };
                });
            }
            store.dispatch(setPreviewCampaignNumberDetails({
                previewCampaings: campaignList,
                selectedCampaingNumberDetails: previewDataAfterRefresh?.selectedCampaingNumberDetails || [],
                campaignSelectedState: false,
                selectedCampaignData: selectedCampaignData
            }));
            if (campaignList.length === 0 && isSettingEnabled('AUTO_DIAL_PREVIEW')) {
                const duration = parseInt(store.getState().toolbar.params.AUTO_DIAL_DURATION, 10);
                const retryAfter = !isNaN(duration) && duration > 0 ? duration : 30;
                let remaining = retryAfter;
                store.dispatch(setPreviewRetryCountdown(remaining));
                const countdownId = setInterval(() => {
                    remaining -= 1;
                    if (remaining <= 0) {
                        clearInterval(countdownId);
                        if (_previewRetryCountdown === countdownId) {
                            _previewRetryCountdown = null;
                        }
                        store.dispatch(setPreviewRetryCountdown(null));
                        return;
                    }
                    store.dispatch(setPreviewRetryCountdown(remaining));
                }, 1000);
                _previewRetryCountdown = countdownId;
                _previewRetryTimer = setTimeout(() => {
                    const mode = store.getState().toolbar.agent.mode;
                    const blendedModeActiveDialer = store.getState().toolbar.blendedModeActiveDialer;
                    const isPreviewMode = mode === "preview" || (mode === "blended" && blendedModeActiveDialer === "Preview");
                    if (isPreviewMode && !store.getState().call.isCallActivityPresent) {
                        getPreviewCampaings(true);
                    } else {
                        clearPreviewRetryTimer();
                    }
                }, retryAfter * 1000);
            } else if (autoSelect && isSettingEnabled('AUTO_DIAL_PREVIEW') && campaignList.length > 0) {
                const mode = store.getState().toolbar.agent.mode;
                const blendedModeActiveDialer = store.getState().toolbar.blendedModeActiveDialer;
                if (mode === "preview" || (mode === "blended" && blendedModeActiveDialer === "Preview")) {
                    getPreviewNumber(campaignList[0]);
                }
            }
        }).catch(e => {
            Logger.error(e);

        })

    }
    catch (e) {
        Logger.error('Unable to get preview Campaings')
        Logger.error(e);
    }
};

let isPreviewNumberRequestInProgress = false;

export async function getPreviewNumber(data) {
    // Check if request is already in progress
    if (isPreviewNumberRequestInProgress) {
        Logger.info("Preview number request already in progress, skipping...");
        return;
    }
    const agentState = store.getState().toolbar.agent.state;
    const previewDataAfterRefresh = store.getState().toolbar.previewCampaignNumberDetails;

    if (agentState === AGENT_STATE.NOT_READY) {
        showWarningNotification("Please change Agent State to ready");
    }
    else {
        isPreviewNumberRequestInProgress = true; // Set flag
        store.dispatch(loading(true));
        try {
            await agentService('tbGetPreviewNumber', {
                params: data.campaignId,
                campaignTrueCallerFlag: data?.trueCallerFlag
            }).then((resp) => {
                if (resp.previewDataResp) {
                    Logger.info("successfull previewDataResponse");
                    let prevData = structuredClone(previewDataAfterRefresh)
                    isPreviewNumberRequestInProgress = false;
                    prevData.selectedCampaignData = data;
                    prevData.campaignSelectedState = true;
                    store.dispatch(setIsPreviewCampaignNumberScreenOpened(true));
                    try {
                        let custInfoApiObj = {
                            monitorUcid: '',
                            agentUserName: getAgentData().agentInfo.agentId,
                            agentUniqId: getAgentData().agentId,
                            customer: getAgentData().customer,
                            dataId: resp.pId,
                            callType: 'preview'
                        }

                        getCustomerInfo(custInfoApiObj).then((resp) => {
                            if (resp[""] === "error") {
                                Logger.error(resp.custData)
                            }
                            else {
                                let cloneOfCustInfo = [];
                                resp.custData.forEach((data) => {
                                    const objKey = data.split('~')[0];
                                    const objEntry = data.split('~')[1];
                                    if (objKey === "PhoneNumber") {
                                        cloneOfCustInfo.push({ name: objKey, value: isMaskNumberEnabled(objEntry) })
                                    } else {
                                        cloneOfCustInfo.push({ name: objKey, value: objEntry })
                                    }
                                })
                                store.dispatch(setPreviewNumberCustomerInfo(cloneOfCustInfo));
                                Logger.log("Successfully got customer information");
                            }
                        }).catch(e => Logger.log(e))
                    }
                    catch (e) {
                        Logger.log(e)
                    }
                    prevData.selectedCampaingNumberDetails = {
                        id: (resp.pId || null),
                        name: (resp.pName || null),
                        email: (resp.pEmail || null),
                        address: (resp.pAddress || null),
                        bankAccount: (resp.pBankAccount || null),
                        phoneNumber: (resp.pNumber || null),
                        prediction: (resp?.prediction != null ? resp?.prediction : null)
                    }
                    store.dispatch(setPreviewCampaignNumberDetails(prevData));
                    store.dispatch(loading(false));
                    if (data.screenpopUrl !== undefined) {
                        try {
                            const previewPopUrl = buildPreviewScreenpopUrl(resp, data);
                            if (previewPopUrl) {
                                openPreviewScreenpop(previewPopUrl, resp.pId || '');
                            }
                        } catch (e) {
                            Logger.error(e);
                        }
                    }
                }
                else {
                    isPreviewNumberRequestInProgress = false;
                    Logger.info(`${resp.message} . Failed PreviewDataResponse`);
                    store.dispatch(loading(false));
                    if (isSettingEnabled('AUTO_DIAL_PREVIEW')) {
                        const mode = store.getState().toolbar.agent.mode;
                        const blendedModeActiveDialer = store.getState().toolbar.blendedModeActiveDialer;
                        const isPreviewMode = mode === "preview" || (mode === "blended" && blendedModeActiveDialer === "Preview");
                        if (isPreviewMode) {
                            const campaignList = store.getState().toolbar.previewCampaignNumberDetails?.previewCampaings || [];
                            const currentIndex = campaignList.findIndex(c => c.campaignId === data.campaignId);
                            const nextCampaign = currentIndex !== -1 && currentIndex + 1 < campaignList.length
                                ? campaignList[currentIndex + 1]
                                : null;
                            if (nextCampaign) {
                                getPreviewNumber(nextCampaign);
                            } else {
                                getPreviewCampaings(false);
                            }
                        }
                    } else {
                        getPreviewCampaings(false);
                    }
                }
            }).catch(e => {
                isPreviewNumberRequestInProgress = false;
                Logger.error(e);
                store.dispatch(loading(false));
            })
        }
        catch (e) {
            isPreviewNumberRequestInProgress = false;
            showErrorNotification('Unable to get Preview Number');
            Logger.error(e);
            store.dispatch(loading(false));
        }
    }
}

export function buildPreviewScreenpopUrl(resp, campaignData) {
    const baseUrl = campaignData.screenpopUrl;
    if (!baseUrl) return null;
    const loginData = getAgentData();
    const toolbarParams = store.getState().toolbar.params;
    let url = baseUrl + (resp.pNumber || '')
        + "&ucid=" + (resp.pId || '')
        + "&callerID=" + (resp.pNumber || '')
        + "&agentUniqueID=" + (loginData?.agentUniqId || '')
        + "&dataID=" + (resp.pId || '')
        + "&campaignID=" + (campaignData.campaignId || '')
        + "&campaignName=" + (campaignData.campaignName || '')
        + "&agentPhoneNumber=" + (loginData?.phoneNumber || '')
        + "&type=Preview"
        + "&apiKey=" + (loginData?.agentInfo?.user?.apiKey || '')
        + "&event=Preview"
        + "&screenpopupType=ClientSide";
    if (toolbarParams.SEND_CUST_PARAMS === 'true') {
        if (toolbarParams.AGENT_ID_PH) {
            url += '&' + toolbarParams.AGENT_ID_PH + '=' + (loginData?.agentInfo?.agentId || '');
        }
        if (toolbarParams.AGENT_KEY_PH) {
            url += '&' + toolbarParams.AGENT_KEY_PH + '=' + (loginData?.agentKey || '');
        }
        if (toolbarParams.CUST_PH) {
            url += '&' + toolbarParams.CUST_PH + '=' + (loginData?.customer || '');
        }
        if (toolbarParams.AGENT_PHONE_PH) {
            url += '&' + toolbarParams.AGENT_PHONE_PH + '=' + (loginData?.phoneNumber || '');
        }
    } else {
        url += "&agentID=" + (loginData?.agentInfo?.agentId || '') + "&customer=" + (loginData?.customer || '');
    }
    return url;
}

function _addToPreviewScreenpopList(ucid) {
    const list = JSON.parse(localStorage.getItem('oz_preview_screenpop_list') || '[]');
    if (!list.includes(ucid)) {
        list.push(ucid);
    }
    localStorage.setItem('oz_preview_screenpop_list', JSON.stringify(list));
}

function _removeFromPreviewScreenpopList(ucid) {
    const list = JSON.parse(localStorage.getItem('oz_preview_screenpop_list') || '[]');
    const updated = list.filter((id) => id !== ucid);
    localStorage.setItem('oz_preview_screenpop_list', JSON.stringify(updated));
}

export function openPreviewScreenpop(previewPopUrl, previewUcid) {
    try {
        if (!isSettingEnabled('AUTO_DIAL_PREVIEW')) return;
        closeAllPreviewScreenpops();
        const screenPopMode = store.getState().toolbar.loginDetails?.agentInfo?.user?.screenPopMode;
        _addToPreviewScreenpopList(previewUcid);
        localStorage.setItem('oz_preview_screenpop_ucid', previewUcid);
        if (screenPopMode === 1) {
            store.dispatch(setScreenpopURL(previewPopUrl));
            store.dispatch(addNewTab('Pop CRM'));
            LocalStorageService.setItem("DashboardActiveTab", 'Pop CRM');
        } else if (screenPopMode === 2) {
            window.open(previewPopUrl, `window${previewUcid}`, 'status=1,width=1024,height=600');
        } else {
            window.open(previewPopUrl, `window${previewUcid}`, '');
        }
    } catch (e) {
        Logger.error(e);
    }
}

export function closePreviewScreenpop() {
    try {
        if (!isSettingEnabled('AUTO_DIAL_PREVIEW')) return;
        const DONT_CLOSE_SPOP = store.getState().toolbar.params.DONT_CLOSE_SPOP;
        if (DONT_CLOSE_SPOP === 'true') return;
        const screenPopMode = store.getState().toolbar.loginDetails?.agentInfo?.user?.screenPopMode;
        const previewUcid = localStorage.getItem('oz_preview_screenpop_ucid');
        if (screenPopMode === 1) {
            store.dispatch(setScreenpopURL(null));
            store.dispatch(removeTab('Pop CRM'));
        } else if (previewUcid) {
            const w = window.open('', `window${previewUcid}`);
            if (w && !w.closed) {
                w.close();
            }
            _removeFromPreviewScreenpopList(previewUcid);
        }
        localStorage.removeItem('oz_preview_screenpop_ucid');
    } catch (e) {
        Logger.error(e);
    }
}

export function closeAllPreviewScreenpops() {
    try {
        if (!isSettingEnabled('AUTO_DIAL_PREVIEW')) return;
        const screenPopMode = store.getState().toolbar.loginDetails?.agentInfo?.user?.screenPopMode;
        if (screenPopMode === 1) {
            store.dispatch(setScreenpopURL(null));
            store.dispatch(removeTab('Pop CRM'));
        } else {
            const list = JSON.parse(localStorage.getItem('oz_preview_screenpop_list') || '[]');
            list.forEach((ucid) => {
                try {
                    const w = window.open('', `window${ucid}`);
                    if (w && !w.closed) {
                        w.close();
                    }
                } catch (e) {
                    Logger.error(e);
                }
            });
        }
        localStorage.removeItem('oz_preview_screenpop_list');
        localStorage.removeItem('oz_preview_screenpop_ucid');
    } catch (e) {
        Logger.error(e);
    }
}


export const handlePreviewReset = async (type) => {
    const blendedModeActiveDialer = store.getState().toolbar.blendedModeActiveDialer;
    const previewDataAfterRefresh = store.getState().toolbar.previewCampaignNumberDetails;
    const campaignSelectedState = previewDataAfterRefresh?.campaignSelectedState || false;
    const selectedCampaingNumberDetails = previewDataAfterRefresh?.selectedCampaingNumberDetails || [];
    const selectedCampaignData = previewDataAfterRefresh?.selectedCampaignData || null;
    const mode = store.getState().toolbar.agent.mode;
    const callData = store.getState().call.callDetails;

    if (callData?.callType === "PreviewDialing" && type === "reset") {
        if ((mode === "blended" && blendedModeActiveDialer === "Preview" && campaignSelectedState) || (mode === "preview" && campaignSelectedState)) {
            await resetPreviewNumber(selectedCampaingNumberDetails?.id, false);
        }
    }
    if (callData?.callType === "PreviewDialing" && type === "getPrevNum") {
        if ((mode === "blended" && blendedModeActiveDialer === "Preview" && campaignSelectedState) || (mode === "preview" && campaignSelectedState)) {
            await getPreviewNumber(selectedCampaignData);
        }
    }
    if (callData?.callType === "PreviewDialing" && type === "getPrevCmp") {
        if ((mode === "blended" && blendedModeActiveDialer === "Preview" && campaignSelectedState) || (mode === "preview" && campaignSelectedState)) {
            await getPreviewCampaings();
        }
    }
}
export function getCallData() {
    return store.getState().call.callDetails;
}

export function getHoldThreshold() {
    let HOLD_ALERT_THRESHOLD = getParam("HOLD_ALERT_THRESHOLD");
    HOLD_ALERT_THRESHOLD = (HOLD_ALERT_THRESHOLD) ? Number(HOLD_ALERT_THRESHOLD) : -1;
    return HOLD_ALERT_THRESHOLD;
}

export const checkHoldThreshold = (time) => {
    const HOLD_ALERT_THRESHOLD = getHoldThreshold();
    if (HOLD_ALERT_THRESHOLD > -1 && time > HOLD_ALERT_THRESHOLD) {
        showErrorNotification("Hold Time of call exceeded more than " + HOLD_ALERT_THRESHOLD + " seconds")
    }
}

export function getTemplates(type) {
    let templates = store.getState().toolbar.sTemplates;
    let filteredTemplates = [] // filtered Templates list based on type ( sms , whatsapp, email etc)
    if (templates) {
        templates.map((data) => {
            if (data.type === type) {
                filteredTemplates.push(data)
            }
        })
        return filteredTemplates || []
    }
}

export function getPauseReasons() {
    let agentData = getAgentData();
    return agentData.pauseReasons || []
}
export function findPauseReason(reason) {
    let pauseReasonsList = getPauseReasons() || []; // Ensure it's always an array
    if (!Array.isArray(pauseReasonsList) || pauseReasonsList.length === 0) {
        console.error("Pause reasons list is empty or invalid.");
        return 0;
    }
    let foundReason = pauseReasonsList.find(item => item.reason === reason);
    return foundReason?.timeLimit || 0; // Safe access with default fallback
}
export const handleSetPause = async (temp) => {
    let callData = store.getState().call.callDetails;
    let agentDetails = getAgentData();
    const disp = store.getState().toolbar.dispositionValues;
    try {
        console.log(temp)
        let reqBody = {
            agentId: agentDetails?.agentInfo?.agentId || '',
            agentUniqId: agentDetails?.agentUniqId || '',
            customer: agentDetails?.customer || '',
            reason: temp?.reason || '',
            ucid: callData?.ucid || '',
            pauseTime: temp?.timeLimit || '',
        }
        let resp = await agentService('tbAddPauseOnCall', reqBody);
        if (resp?.status === "success") {
            LocalStorageService.setObject('dispPauseReason', temp);
            store.dispatch(setPauseReason(temp));
            let dispObj = structuredClone(disp);
            dispObj.reason = temp;
            dispObj.pauseReasonState = true
            store.dispatch(setDispositionValues(dispObj));
        } else {
            showErrorNotification("Unable to schedule the pause.")
        }
    }
    catch (e) {
        Logger.error(e);
        store.dispatch(loading(false));
    }
}
export const handlePauseRemove = async (type) => {
    let agentDetails = getAgentData();
    const disp = store.getState().toolbar.dispositionValues;
    try {
        let reqBody = {
            agentId: agentDetails?.agentInfo?.agentId || '',
            agentUniqId: agentDetails?.agentUniqId || '',
            customer: agentDetails?.customer || '',
        }
        let resp = await agentService('tbRemovePauseOnCall', reqBody);
        if (resp?.status === "success") {
            store.dispatch(pauseToggle(false));
            LocalStorageService.setItem('dispPauseState', false);
            LocalStorageService.setObject('dispPauseReason', '');
            store.dispatch(setPauseReason(''));
            let dispObj = structuredClone(disp);
            dispObj.reason = null;
            dispObj.pauseReasonState = false
            store.dispatch(setDispositionValues(dispObj));
            showSuccessNotification("Pause removed successfully.")

        } else {
            showErrorNotification("Unable to remove the pause.")
        }
    }
    catch (e) {
        showErrorNotification('Unable to remove the pause.');
        Logger.error(e);
    }
}


export const handleToggle = (value) => {
    if (value) {
        store.dispatch(pauseToggle(value));
        LocalStorageService.setItem('dispPauseState', true);
    }
    else {
        handlePauseRemove();
    }
};
export function setAgentDataBeforeReload() {
    let answeredChats = store.getState().digital.answeredChats;
    let simplifiedAnsweredChats = {};
    Object.keys(answeredChats).forEach(key => {
        const chatCustSessionId = answeredChats[key].chatCustSessionId;
        const count = answeredChats[key].count;
        simplifiedAnsweredChats[chatCustSessionId] = { count };
    });
    localStorage.setItem('answeredChatDetailsForChatInactivity', JSON.stringify(simplifiedAnsweredChats))
    LocalStorageService.setItem('reconnect', true);
    sessionStorage.setItem('sessionReconnect', true);
    LocalStorageService.setItem("isCallEnded", store.getState().call.isCallEnded);
    LocalStorageService.setItem("DashboardTabs", store.getState().dashboard.visibleTabs)
    LocalStorageService.setItem("DashboardActiveTab", store.getState().dashboard.activeTab)
    LocalStorageService.setItem("homePageLogo", store.getState().toolbar.headerLogo)
    LocalStorageService.setItem("activeToggle", store.getState().toolbar.activeToggle)
    store.dispatch(setAgentStateDuration(getTimer()))
    store.dispatch(setAutoUpdateAgentState({ countDown: getCountDown(), altered: store.getState().timer.autoUpdateAgentState.altered }))
    LocalStorageService.setObject("agentCountDown", { countDown: getCountDown(), altered: store.getState().timer.autoUpdateAgentState.altered });
    LocalStorageService.setItem('showMinimizedCall', store.getState().toolbar.showMinimizedCall)
    LocalStorageService.setItem('blendedModeActiveDialer', store.getState().toolbar.blendedModeActiveDialer);
    LocalStorageService.setObject('declinedChatsMonitorUcids', (store.getState().digital.declinedChatsMonitorUcids !== undefined && store.getState().digital.declinedChatsMonitorUcids !== null && store.getState().digital.declinedChatsMonitorUcids !== "undefined" && store.getState().digital.declinedChatsMonitorUcids !== "null") ? store.getState().digital.declinedChatsMonitorUcids : []);
    LocalStorageService.setItem("chatSessionId", store.getState().digital.activeSessionId);
    LocalStorageService.setItem("isChatActive", store.getState().digital.isChatActive);
    LocalStorageService.setItem('usId', store.getState().toolbar.usId);
    store.dispatch(setTimeAfterPauseReason(LocalStorageService.getItem('pauseTimeCompleted')))
}

const disconnectOngoingCall = async () => {
    const { callData, isCallAttended } = store.getState().call;
    if (callData && isCallAttended) {
        endCurrentCall();
    }
}

export function clearSession(forced = false, redirectToLogin = false) {
    setTimeout(() => {
        sipService.stopSIP();
        sipService.clearSIP();
        WSocketService.closeConnection();
        LocalStorageService.removeItem('pin');
        LocalStorageService.removeItem('selectedCampaign');
        LocalStorageService.removeItem('transferActiveTab');
        LocalStorageService.removeItem('DashboardActiveTab');
        LocalStorageService.removeItem('PreviewCampaignNumberDetails');
        LocalStorageService.removeItem('blendedModeActiveDialer');
        LocalStorageService.removeItem('maxPauseTime');
        LocalStorageService.removeItem('logoutStartTime');
        LocalStorageService.removeItem('pauseTimeCompleted');

        let timeRemain = localStorage.getItem('timeTakenToSub');

        //For mobile
        LocalStorageService.removeItem('loginDetails')

        let showingToolbarInCrm = store?.getState()?.toolbar?.showingToolbarInCrm;

        disconnectOngoingCall();
        let ring_audio = ((localStorage.getItem('ring_audio')) || null)
        let beep_audio = ((localStorage.getItem('beep_audio')) || null)
        let call_audio = ((localStorage.getItem('call_audio')) || null)
        let chat_audio = ((localStorage.getItem('chat_audio')) || null)
        let activeToggle = ((localStorage.getItem('activeToggle')) || null)
        sessionStorage.clear();
        localStorage.clear()
        localStorage.setItem("timeTakenToSub", timeRemain)

        localStorage.setItem('ring_audio', ring_audio)
        localStorage.setItem('beep_audio', beep_audio)
        localStorage.setItem('call_audio', call_audio)
        localStorage.setItem('chat_audio', chat_audio)
        localStorage.setItem('activeToggle', activeToggle)
        store.dispatch(setOTPVerify(false))
        store.dispatch({ type: "Clear" });
        store.dispatch(setActiveToggle(activeToggle))
        unRegisterServiceWorker();
        forceCloseAllNotification();
        console.log("forced,showingToolbarInCrm,redirectToLogin : ", forced,showingToolbarInCrm, redirectToLogin);
        if (redirectToLogin) {
            // dedicated path for session-terminated / toolbarLogout -> always land on the login page
            // strip action=formLogin (with or without a trailing &) so the login page doesn't re-trigger the auto form-login flow
            let search = window.location.search.replace(/[?&]?action=formLogin/ig, "");
            // normalise leftover separators so the remaining params start with a single '?'
            search = search.replace(/^&/, "");
            if (search && !search.startsWith("?")) {
                search = "?" + search;
            }
            console.log("clearSession -> : redirecting to login page")
            window.location.href = '/login' + search;
            return;
        }
        if (forced) {
            let search = window.location.search;
            if (search && search.length && search.includes('action=formLogin')) {
                search = search.replace(/[\\?|&]?(action=formLogin&)/ig, "")
                console.log("clearSession -> : navigating to login page")
                window.location.href = '/login?' + search;
            } else {
                if (!showingToolbarInCrm) {
                    window.location.reload(false);
                }
            }
        } else {
            if (!showingToolbarInCrm) {
                window.location.reload(false);
            }
        }
    }, 100);
}

const avatarColor = (alphabet) => {
    var color = { 'A': "#EBADAD", 'B': "#FCC6AA", 'C': "#EAE1CD", 'D': "#FFD993", 'E': "#DDFFA9", 'F': "#9CEDE9", 'G': "#A4A4C9", 'H': "#EBADAD", 'I': "#FCC6AA", 'J': "#CCB091", 'K': "#FFD993", 'L': "#DDFFA9", 'M': "#9CEDE9", 'N': "#FCC6AA", 'O': "#A4A4C9", 'P': "#EBADAD", 'Q': "#FCC6AA", 'R': "#CCB091", 'S': "#FFD993", 'T': "#DDFFA9", 'U': "#9CEDE9", 'V': "#A4A4C9", 'W': "#EBADAD", 'X': "#FCC6AA", 'Y': "#CCB091", 'Z': "#FFD993" }
    return color[alphabet];
}

export const stringAvatar = (name) => {
    if (name !== undefined && name !== null) {
        if (name.length > 0) {
            let nameparts = name.split(' ');
            if (nameparts.length < 2) {
                nameparts = nameparts[0].split('_');
            }
            let alphabet = nameparts[0][0].toUpperCase();
            return {
                sx: {
                    bgcolor: avatarColor(alphabet),
                },
                children:
                    (nameparts.length === 1) ?
                        nameparts[0][0].toUpperCase() :
                        (nameparts[0][0] + nameparts[1][0]).toUpperCase()
            };
        }
    }
    else {
        return {
            sx: {
                bgcolor: avatarColor('A'),
            },
            children:
                'a'.toUpperCase()
        };
    }
};

export function checkDashboardItemVisibility(item) {
    switch (item) {
        case 'Dashboard':
            let tbDashboard = getParam("TOOLBAR_DASHBOARD");
            return tbDashboard === "true" || tbDashboard === true;
        case 'Performance':
            let agentPerformance = getParam("AGENT_PERFORMANCE");
            return agentPerformance === "true" || agentPerformance === true
        case 'History':
            let agentData = getAgentData();
            return agentData.hasOwnProperty('userRoles') ? agentData.userRoles.ach === 1 : false;
        case 'Interaction Hub':
            let status = getIHstatus();
            return status || false
        case 'Qa Agent Performance':
            return isSettingEnabled("QA_AGENT_DETAILS");
        default:
            return true;
    }
}
export const getIHstatus = () => {
    const ROLE_BLENDED = getRoleStatus("ROLE_BLENDED");
    const ROLE_CHAT = getRoleStatus("ROLE_CHAT");
    const agentInfo = store.getState().toolbar.loginDetails.agentInfo || []; // for modes list in blended
    const ROLE_AI = getRoleStatus("ROLE_AI"); // chat 
    const AGENT_TRANSCRIBE = (isSettingEnabled('VOICE_TRANSCRIPTION')); // transcribe for call 
    if (ROLE_AI && AGENT_TRANSCRIBE) {  // AGENT_ASSIST  is only for chat 
        return true;
    } else if ((ROLE_CHAT && agentInfo?.chat) || (ROLE_BLENDED && agentInfo?.blendedChat)) {
        return true
    } else {
        return false;
    }
}
export const onReadyGetParkingChatsCount = async () => {
    try {
        const mode = store.getState().toolbar.agent.mode;
        const ROLE_BLENDED = getRoleStatus("ROLE_BLENDED");
        const ROLE_CHAT = getRoleStatus("ROLE_CHAT");
        const agentInfo = store.getState().toolbar.loginDetails.agentInfo || []; // for modes list in blended
        if (((ROLE_CHAT && agentInfo?.chat) || (ROLE_BLENDED && agentInfo?.blendedChat)) && (mode.trim() === 'chat' || mode === 'blended')) {
            const activeTab = store.getState().dashboard.activeTab;
            if (activeTab === 'Interaction Hub') {
                await getQueueChatsCount();
            } else {
                let resp = await getQueueChatsCount();
                if (resp && resp.status === "success") {
                    const whatsappCount = Number(resp?.count || 0);
                    const smsCount = Number(resp?.smsCount || 0);
                    if (whatsappCount > 0 || smsCount > 0) {
                        store.dispatch(setActiveTab('Interaction Hub'));
                        LocalStorageService.setItem("DashboardActiveTab", 'Interaction Hub');
                    }
                }
            }
            store.dispatch(setChatParkingApiCount(1));
        }
    } catch (e) {
        console.log("An error occurred while changing the Interaction Hub tab", e);
    }
}
export const getParkingChatCount = async () => {
    try {
        let resp = await getQueueChatsCount();
        if (resp && resp.status === "success") {
            const whatsappCount = Number(resp?.count || 0);
            const smsCount = Number(resp?.smsCount || 0);
            store.dispatch(setChatParkingApiCount(1)); // api call count increasing other wise it will called every time if count is 0
            if (whatsappCount > 0 || smsCount > 0) {
                const ROLE_BLENDED = getRoleStatus("ROLE_BLENDED");
                const ROLE_CHAT = getRoleStatus("ROLE_CHAT");
                const agentInfo = store.getState().toolbar.loginDetails.agentInfo || []; // for modes list in blended
                const isChatEnabled = ROLE_CHAT && agentInfo?.chat;
                const isBlendedEnabled = ROLE_BLENDED && agentInfo?.blendedChat;
                if (isChatEnabled || isBlendedEnabled) {
                    store.dispatch(setParkingChatsCount({
                        whatsapp: whatsappCount,
                        sms: smsCount
                    }));
                    store.dispatch(setActiveTab('Interaction Hub'));
                    LocalStorageService.setItem("DashboardActiveTab", 'Interaction Hub');
                }
            } else {
                console.log("IH: No pending chats, setting default mode");
            }
        } else {
            console.log("IH: API call returned non-success status", resp?.status);
        }
    } catch (error) {
        console.error("IH: Execution error in getParkingChatCountOnLogin", error);
    }
};

export function handlePauseOnBusyRelease(item) {
    store.dispatch(showPauseAfterSessionTime(false))    // to show regular timer   removing digital chat component
    store.dispatch(pauseAfterSession({ type: false, reason: null }))   // making pause reason as null
    store.dispatch(showExceededTimelimit(false))  // to show timer in red color false
    store.dispatch(pauseTimeExceeded(false))  // to show time exceeded lable    
    localStorage.removeItem("pauseAfterSessionTime")  // refresh timer 
}


const shouldShowPATab = () => {
    const paParam = getParam('PA_URL');
    try {
        const parsed = typeof paParam === 'string' ? JSON.parse(paParam) : paParam;
        return (
            parsed !== null &&
            typeof parsed === 'object' &&
            !Array.isArray(parsed) &&
            Object.keys(parsed).length > 0
        );
    } catch (e) {
        return false;
    }
};
export function getAvailableDashboardItems() {
    try {
        let AGENT_DEFAULT_TAB = getParam("AGENT_DEFAULT_TAB")

        const data = store.getState()?.toolbar?.loginDetails;
        const custWebsite = data?.custWebsite || null;
        const showPa = shouldShowPATab();
        const filteredMenuList = sideMenuList.filter(item => {
            if (item === 'My CRM') return !!custWebsite; // Keep if custWebsite is truthy
            if (item === 'PA') return showPa;            // Keep if showPa is true
            return true;                                 // Keep everything else
        });

        const filteredTabs = filteredMenuList.filter((tab) => checkDashboardItemVisibility(tab));
        let tab = AGENT_DEFAULT_TAB === "MyCRM" ? "My CRM"
            : AGENT_DEFAULT_TAB === "Performance" ? "Performance"
                : AGENT_DEFAULT_TAB === "CallHistory" ? "History"
                    : AGENT_DEFAULT_TAB === "Dashboard" ? "Dashboard" : AGENT_DEFAULT_TAB === "PA" ? "PA" : "Dashboard"
        const defaultTabIndex = filteredTabs.indexOf(tab);
        if (defaultTabIndex !== -1) { // shifting default tab to first place
            filteredTabs.splice(defaultTabIndex, 1);
            filteredTabs.unshift(tab);
        }
        store.dispatch(setActiveTab(tab))
        return filteredTabs
    } catch (e) {
        console.log("default tab error : ", e);
    }
}

let stateTimer = null;
export function setTimer(timer) {
    stateTimer = timer
}

export function getTimer() {
    return stateTimer
}

let countDown = 0
export function countdownTimer(seconds) {
    const EXCEPTION_ON_NO_HEADPHONE = getParam('EXP_ON_NO_HEADPHONE') === "true" || false;

    countDown = seconds
    const intervalId = setInterval(() => {
        const isSIPconnected = store.getState().toolbar.isSIPconnected;
        const isSip = store.getState().toolbar.loginDetails.isSip;

        countDown = countDown - 1;
        if (countDown <= 1) {
            store.dispatch(setNotReadyTimeOut(true));

        }
        if (countDown <= 0) {
            let isHeadphoneConnectedStatus = store.getState().toolbar.isHeadphoneConnectedStatus;
            if (isSip && (EXCEPTION_ON_NO_HEADPHONE && !isHeadphoneConnectedStatus)) {
                return
            }
            if (isSIPconnected || !isSip) {
                store.dispatch(setAutoUpdateAgentState({ countDown: countDown, altered: store.getState().timer.autoUpdateAgentState.altered }))
            }
            if (!isSIPconnected && isSip) {
                releaseAgent();
            }
            clearInterval(intervalId)
        }
    }, 1000);
}

export function getCountDown() {
    return countDown;
}

export function notifyNewChat(message) {
    const sender = message.custName !== undefined ? message.custName : 'Anonymous';
    handleTbNotifications({ alertType: 'Notice', msg: "Chat from " + sender, type: "incomingChat" });
    playMsgAlert()
}
export function playMsgAlert() {
    try {
        var chatNotify = document.getElementById("chatNotify");
        chatNotify.play();
    } catch (e) {
        Logger.e(e)
    }
}
const getcustData = (data) => {
    let obj = []
    data && data.map((e) => {
        obj.push({ key: e.name + ": ", value: e.value || null })

    })
    return obj
}
export function buildCallData(state) {
    let HIDE_UUI = isSettingEnabled('HIDE_UUI');
    if (state.call.callDetails !== null && Object.keys(state.call.callDetails).length > 0) {
        const custInfo = (state.call.callDetails.custInfo !== undefined && state.call.callDetails.custInfo !== null) ? state.call.callDetails.custInfo : [];
        const resolveCallDetails = () => {
            try {
                return (!(getParam("MASK_CUSTOMER_NUMBER") === 'false' || getParam("MASK_CUSTOMER_NUMBER") === false) && state.call.callDetails.callerId.substr(-10) === state.call.callDetails.uui ? isMaskNumberEnabled(state.call.callDetails.callerId) : HIDE_UUI ? '' : state.call.callDetails.uui || state.call.callDetails.callType);
            }
            catch (e) {
                const uuiValue = HIDE_UUI ? '' : state.call.callDetails?.uui;
                return uuiValue || state.call.callDetails?.callType || '';
            }
        }
        return {
            allCallData: state.call.callDetails,
            comments: state.call.callDetails.comments,
            transferedBy: state.call.callDetails.transferedBy,
            transferComments: state.call.callDetails.transferComments,
            waitTime: state.call.callDetails.waitTime !== undefined ? state.call.callDetails.waitTime : null,
            customerInformation: getcustData(custInfo)
            ,
            callDetails: [
                { key: "Agent ID: ", value: getAgentData().agentInfo.agentId },
                { key: "Agent Number: ", value: getAgentData().phoneNumber },
                { key: "Skill Name: ", value: state.call.callDetails.skillName },
                { key: "Call Details: ", value: resolveCallDetails() },
                { key: "UCID: ", value: state.call.callDetails.ucid },
                { key: "Monitor UCID: ", value: state.call.callDetails.monitorUcid },
                { key: "Campaign: ", value: state.call.callDetails.campaignName },
                state?.call?.callDetails?.uui?.includes("cid_name") && {
                    key: "cid_name: ",
                    value: getCIDname(state?.call?.callDetails?.uui)
                },
            ]
        }
    }
    else {
        return null
    }
}

const getCIDname = (uui) => {
    try {
        const parsed = JSON.parse(uui);
        return parsed?.cid_name || '';
    } catch (error) {
        console.warn("Invalid UUI JSON:", uui, error);
        return '';
    }
};

export const displayChatOnCallMiniWindow = () => {
    const { agent: { mode }, showMinimizedCall } = store.getState().toolbar
    if ((mode === MODES.BELNDED || mode === MODES.INBOUND) && !showMinimizedCall && store.getState().call.isCallAttended) {
        store.dispatch(minimizeCall(true))
        store.dispatch(setIsComponentOnCall(false));
        store.dispatch(setIsCallAttended(false));
    }
}

export function getToolbarState() {
    const { isComponentOnCall, callDetails, isCallEnded, isCallAttended, isCallIncomming } = store.getState().call;
    switch (true) {
        case isCallAttended: return "Busy";
        case isCallIncomming: return callDetails ? (callDetails.callType === 'Progressive Dialing') ? "Dialing" : "Incoming" : "Incoming";
        case isComponentOnCall: return "Dialing";
        case store.getState().toolbar.isChatWaiting: return "Calling..";
        case isCallEnded: return "ACW";
        default: return store.getState().toolbar.agent.state;
    }
}
export function CancelorCloseDisposition() {
    try {

        const isCallBackCallNotAttended = store.getState().call.isCallBackCallNotAttended.cbState;
        if (isCallBackCallNotAttended) {
            store.dispatch(setDispositionValues({
                rescheduleDateTime: null,
                rescheduleComment: null,
                reason: null,
                pauseReasonState: false,
                callBackTimezoneSelected: null,
                forceRedialAfterDispose: false
            }));
            store.dispatch(setCurrentLocationTimeAndRescheduleTime({
                currentLocationTime: null,
                rescheduleDateTime: null
            }))
            localStorage.removeItem("rescheduleDateAndTime");
            LocalStorageService.removeItem('dispDateAndTime');
            LocalStorageService.removeItem('dispComment');
            LocalStorageService.removeItem('dispPauseState');
            LocalStorageService.removeItem('dispPauseReason');
            LocalStorageService.removeItem('dispZone');
            LocalStorageService.removeItem('dispCurrentLocationTime');
            LocalStorageService.removeItem('forceRedialAfterDispose');
            store.dispatch(setIsCallBackCallNotAttended({
                cbState: false,
                cbId: null,
                cbNumber: null,
            }))
        }
        store.dispatch(handleDispositionEnable(false))
    }
    catch (e) {
        Logger.error("Exception while closing disposition", e)
    }
}

export const copyToClipboard = (text) => {
    try {
        navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
            if (result.state === "granted" || result.state === "prompt") {
                navigator.clipboard.writeText(text).then(() => {
                    Logger.log("Text copied to clipboard")
                    showSuccessNotification("Copied")
                }, () => {
                    Logger.log("Failed to copy the text to clipboard")
                    showErrorNotification("Failed to copy")
                });
            }
        });
    }
    catch (e) {
        Logger.error("Error while copying to clipboard", e)
        showErrorNotification("Failed to copy")
    }
}

export const getRoleStatus = (role) => {
    try {
        const isRoleAvl = getAgentData()?.roles?.some(element => element.name === role);
        return isRoleAvl ? true : false;
    }
    catch (e) {
        Logger.error("Error while role checking", e);
    }
}
export function updateTimer(value) {
    const isComponentOnCall = store.getState().call.isComponentOnCall;
    const Role_Chat_call = getRoleStatus("ROLE_CHAT_CALL");
    let mode = store.getState().toolbar.agent.mode;
    const showMinimizedCall = store.getState().toolbar.showMinimizedCall;
    if (Role_Chat_call && mode === "blended") {
        if (!isComponentOnCall && !showMinimizedCall) {
            store.dispatch(setReUpdateTimer(value));
        }
    } else {
        store.dispatch(setReUpdateTimer(value));
    }
}

export function sendDataToIframe() {
    try {
        const callData = store.getState().call.callDetails;
        const iframe = document.getElementById('OzonetelMyCRM');
        if (iframe && iframe.contentWindow) {
            const agentInfo = getAgentData()?.agentInfo || {};
            iframe.contentWindow.postMessage({
                action: "mycrm",
                data: {
                    callerId: callData?.callerId || '',
                    did: callData?.did || '',
                    agentId: agentInfo?.agentId || '',
                    monitorUcid: callData?.monitorUcid || '',
                    agentUniqueID: callData?.agentUniqueID,
                    id: agentInfo?.id || '',
                    ucid: callData?.ucid || '',
                    skillName: callData?.skillName || '',
                    agentData: getAgentData()?.agentData || ''
                }
            }, "*");
        } else {
            console.warn("Iframe is not open. Please check")
        }
    } catch (error) {
        console.error("Error in postMessage:", error);
    }
}
export const handleAgentExceptionState = async () => {
    const isComponentOnCall = store.getState().call.isComponentOnCall;
    let mode = store.getState().toolbar.agent.mode;
    const isCallEnded = store.getState().call.isCallEnded;
    const isCallAttended = store.getState().call.isCallAttended;
    const isExceptionEnabled = store.getState().toolbar.isExceptionEnabled;
    const isCallInComming = store.getState().call.isCallIncomming;
    const agentState = store.getState().toolbar.agent.state;
    const callData = store.getState().call.callDetails;
    let pauseReason = store.getState().timer.pauseReason;
    let isHeadphonesConnected = store.getState().toolbar.isHeadphoneConnectedStatus;
    const EXCEPTION_ON_NO_HEADPHONE = getParam('EXP_ON_NO_HEADPHONE') === "true" || false;
    try {
        if (EXCEPTION_ON_NO_HEADPHONE) {
            if (!isHeadphonesConnected) {
                if (!isComponentOnCall && !isCallAttended && isCallEnded && (pauseReason === "" || pauseReason === null)) {
                    let reqBody = {
                        mode: mode ? mode.toUpperCase() : "", // Ensure mode is a valid string
                        state: "EXCEPTION",
                        stateReason: "Connect the headphone to take the calls"
                    };
                    const resp = await agentService("tbSetAgentState", reqBody);
                    if (resp?.resp === "Success") {
                        showErrorNotification("Connect the headphone to take the calls");
                        let temp = {
                            reason: "EXCEPTION",
                            timeLimit: 0
                        }
                        store.dispatch(setPauseReason(temp));
                        if (agentState === AGENT_STATES.NOT_READY || isCallInComming) {
                            await releaseAgent({ mes: "forceReleaseByAgent" });
                            if (isCallAttended) {
                                store.dispatch(loading(true));
                                store.dispatch(setDispositionReqbody(null));
                                store.dispatch(handleDispositionEnable(false));
                                store.dispatch(setDispositionValues({
                                    rescheduleDateTime: null,
                                    rescheduleComment: null,
                                    reason: null,
                                    pauseReasonState: false,
                                    callBackTimezoneSelected: null,
                                }));
                                store.dispatch(clearMultiDisposition())
                                LocalStorageService.removeItem("rescheduleDateAndTime");
                                LocalStorageService.removeItem("CancelDispositionScreen");
                                LocalStorageService.removeItem('dispDateAndTime');
                                localStorage.removeItem('timeTakenToSub');
                                LocalStorageService.removeItem('dispComment');
                                LocalStorageService.removeItem('dispPauseState');
                                LocalStorageService.removeItem('dispPauseReason');
                                LocalStorageService.removeItem('dispZone');
                                LocalStorageService.removeItem('dispCurrentLocationTime');
                                LocalStorageService.removeItem('forceRedialAfterDispose');
                                dropAgentFromCall("agentReleaseWOACW", true);
                            }
                            else if (isComponentOnCall || isCallInComming || isCallEnded) {
                                handleDropCall({ type: "agentReleaseWOACW", ucid: callData.ucid, })
                            }
                        }
                        store.dispatch(setAgentStateDuration(0));
                        store.dispatch(setExceptionState(true));
                    }
                }
            } else {
                if (isExceptionEnabled) {
                    store.dispatch(setExceptionState(false));
                    releaseAgent();
                }
            }
        }
    } catch (e) {
        Logger.error(e);
        store.dispatch(loading(false));
    }
}


export function isLoginDataPresent(checkingFncName) {
    let agentData = store.getState().toolbar.loginDetails;
    if (agentData === null || agentData === undefined || Object.keys(agentData).length === 0) {
        console.log(`Agent Login details are not available. Checing in Fnc:(${checkingFncName})`);
        return false;
    } else {
        return true;
    }
}

export const preLogin = async () => {
    try {
        const response = await HttpService.get("preLoginURL", {});
        if (response.status === 403) {
            throw new Error('FORBIDDEN_ACCESS');
        }
        return response;
    } catch (err) {
        console.log('Pre Login Error', err);
        return err;
    }
}
export const isChatsPresent = () => {
    let answeredChats = store.getState().digital.answeredChats;
    let unansweredChats = store.getState().digital.unansweredChats;
    const isChatsAvl = ((Object.keys(answeredChats).length > 0) || (Object.keys(unansweredChats).length > 0)) || false;
    return isChatsAvl;
}
export function constructURL(urlStrig, apiID, userid, agentid) {
    let source = 'cxtoolbar'

    if (isMobileApp()) {
        source = 'cxtoolbar_ma'
    } else if (isMobileDevice()) {
        source = 'cxtoolbar_mb'
    }

    try {
        let params = {
            userID: userid,
            apiID: apiID,
            agentID: agentid,
            requestTime: new Date().toISOString(),
            source: source,
            uui: generateIdID(userid),
        }
        let url = new URL(urlStrig);
        const Qparams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== null && value !== undefined) {
                Qparams.append(key, String(value)); // Explicitly convert to string
            }
        });
        url.search = Qparams.toString();
        return url.toString();
    } catch (error) {
        console.error("Error constructing URL with Params:", error);
        return urlStrig;
    }

}
function generateIdID(userId) {
    const timestamp = Date.now();
    const seed = (userId * 9301 + 49297) % 233280;
    const rnd = (seed * 9301 + 49297) % 233280;
    const derivedNumber = Math.floor((rnd / 233280) * 1000000); // Increased range
    const microTime = Math.floor(Math.random() * 1000);
    return `${timestamp}${derivedNumber}${microTime}`;
}

export const removeScreenpopFromStorage = (name) => {
    try {
        const screenpopData = JSON.parse(localStorage.getItem("popupData")) || [];
        const updatedData = screenpopData.filter((item) => item !== name);
        localStorage.setItem("popupData", JSON.stringify(updatedData));
    } catch (e) {
        console.log("error: while removing screen pop ", e)
    }
};
export async function getCampaigns() {
    try {
        const resp = await agentService('tbGetCampaigns', {});
        let respStatus = Object.keys(resp)
        if (respStatus.includes("status") || respStatus.includes("message")) {
            Logger.error("unable to get campaign list")
        } else {
            if (resp.campList) {
                store.dispatch(setManualData({ campaignsList: resp.campList }));
            }
            Logger.info("Successfully accesed campaign list")
        }
    } catch (e) {
        Logger.error(e);
    }
}

export async function getTransferNumbers() {
    try {
        agentService('tbGetTransferList', {
            transferType: 3,
        }).then((resp) => {
            if (resp.status === "Success") {
                const newData = resp.message.map((item) => ({
                    ...item,
                    optionLabel: `${item.transferName}~${item.transferNumber}`,
                }));
                store.dispatch(setManualData({ phoneNumbersList: newData }));
                Logger.info("Successfully accessed phone number list api")
            }
            else {
                Logger.error("unable to get phone number list")
            }
        }
        ).catch(e => {
            Logger.error(e);
        })
    } catch (e) {
        Logger.error(e);
    }
}
export const isMobileApp = () => {
    let token = LocalStorageService.getItem('fcmtoken');
    if (token) {
        return token;
    } else {
        return false;
    }
}
export async function getHeaderImages(endpoint) {
    try {
        let url = HttpService.getURL('login-bg-img');
        const response = await fetch(url + endpoint + ".js", {});

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.text();
        const urlRegex = /(https:\/\/\S+)/g;
        const urls = result.match(urlRegex);

        return urls; // This promise will now resolve with the urls array

    } catch (error) {
        console.error("error in api: ", error);
        return null; // This promise will now resolve with null
    }
}

export function isMobileDevice() {
    try {
        // Check 1: Touch support
        const hasTouch = ('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0);
        // Check 2: Screen size (actual device screen, not viewport)
        const smallScreen = window.screen.width <= 768 || window.screen.height <= 768;
        // Check 3: Mobile-specific window properties
        const mobileOrientation = typeof window.orientation !== 'undefined';
        // Check 4: User Agent (as fallback, since it can be spoofed)
        const mobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        // Check 5: CSS mobile detection
        const mobileCSSMatch = window.matchMedia('(pointer: coarse) and (hover: none)').matches;
        // Check 6: Platform detection (more reliable than UA)
        const mobilePlatform = /Android|iPhone|iPad|iPod/i.test(navigator.platform || '');
        // Scoring system: More true conditions = more likely mobile
        let mobileScore = 0;
        if (hasTouch) mobileScore += 2;        // Touch is strong indicator
        if (smallScreen) mobileScore += 2;      // Small screen is strong indicator
        if (mobileCSSMatch) mobileScore += 2;   // CSS pointer/hover is reliable
        if (mobileOrientation) mobileScore += 1;
        if (mobileUA) mobileScore += 1;
        if (mobilePlatform) mobileScore += 1;
        // If score >= 4, it's almost certainly mobile
        // This works even when "Request Desktop Site" is enabled
        // Usage
        if (mobileScore >= 4) {
            console.log("Mobile browser detected");
        } else {
            console.log("Desktop browser detected");
        }
        return mobileScore >= 4;
    } catch (e) {
        console.log("error: in is mobile device identification ", e)
    }
}

export function getUserId() {
    return store.getState()?.toolbar?.userId;
}

function setUserId(agentData) {
    try {
        const userId = agentData?.agentInfo?.user?.id;
        if (userId !== undefined && userId !== null && userId !== '') {
            store.dispatch(setAgentUserId(userId))
        } else {
            console.log('userId is not found for agent:', agentData?.agentInfo?.agentId)
        }

    } catch (error) {
        console.error("Failed to set userId :", error);
    }
}

export const generateUniqSessionId = () => {
    let sessionId = uuidv4();
    store.dispatch(setBrowserSessionId(sessionId))
    console.log("Session created..");
    return sessionId;
}

export const getBrowserSessionId = () => {
    return store.getState().toolbar.sessionId || null;
}


